/* Sandal Factory premium sliding-outline header. Theme-editor-safe, no dependencies. */
(function(){
  function initialize(){
    document.querySelectorAll('[data-sf-premium-header]').forEach(function(root){
      if(root.dataset.sfPremiumReady==='true')return;
      root.dataset.sfPremiumReady='true';
      var nav=root.querySelector('[data-sf-premium-nav]');
      var glider=root.querySelector('[data-sf-premium-glider]');
      var drawer=root.querySelector('[data-sf-premium-drawer]');
      var active=nav&&nav.querySelector('[data-sf-premium-active]');
      var selected=null;
      function place(target){
        if(!nav||!glider)return;
        if(!target || window.matchMedia('(max-width:900px)').matches){
          glider.classList.remove('is-visible');return;
        }
        var base=nav.getBoundingClientRect(),rect=target.getBoundingClientRect();
        if(!rect.width)return;
        glider.style.width=rect.width+'px';
        glider.style.height=rect.height+'px';
        glider.style.transform='translate3d('+(rect.left-base.left)+'px,'+(rect.top-base.top)+'px,0)';
        glider.classList.add('is-visible');
      }
      function restore(){selected=null;place(active);}
      if(nav&&glider){
        nav.addEventListener('pointerover',function(e){
          var link=e.target.closest('[data-sf-premium-target]');
          if(!link || !nav.contains(link))return;
          selected=link;place(link);
        });
        nav.addEventListener('pointerleave',restore);
        nav.addEventListener('focusin',function(e){
          var link=e.target.closest('[data-sf-premium-target]');
          if(link){selected=link;place(link);}
        });
        nav.addEventListener('focusout',function(){
          requestAnimationFrame(function(){
            var focus=nav.contains(document.activeElement)?document.activeElement.closest('[data-sf-premium-target]'):null;
            if(focus){selected=focus;place(focus)}else{restore();}
          });
        });
        requestAnimationFrame(function(){place(active);});
        if(typeof ResizeObserver!=='undefined'){
          var observer=new ResizeObserver(function(){place(selected||active);});
          observer.observe(nav);
        }
        window.addEventListener('resize',function(){place(selected||active);},{passive:true});
      }
      if(drawer){
        var trigger=root.querySelector('[data-sf-premium-open]');
        var closeBtn=root.querySelector('[data-sf-premium-close]');
        var backdrop=root.querySelector('[data-sf-premium-backdrop]');
        var previousOverflow='';
        function openState(){return root.classList.contains('sf-premium-header--drawer-open');}
        function closeDrawer(focus){
          if(!openState())return;
          root.classList.remove('sf-premium-header--drawer-open');
          drawer.setAttribute('aria-hidden','true');
          drawer.setAttribute('inert','');
          trigger.setAttribute('aria-expanded','false');
          document.body.style.overflow=previousOverflow;
          if(focus)trigger.focus();
        }
        function openDrawer(){
          if(openState())return;
          previousOverflow=document.body.style.overflow;
          drawer.removeAttribute('inert');
          drawer.setAttribute('aria-hidden','false');
          root.classList.add('sf-premium-header--drawer-open');
          trigger.setAttribute('aria-expanded','true');
          document.body.style.overflow='hidden';
          closeBtn.focus();
        }
        if(trigger)trigger.addEventListener('click',function(){if(openState())closeDrawer(true);else openDrawer();});
        if(closeBtn)closeBtn.addEventListener('click',function(){closeDrawer(true);});
        if(backdrop)backdrop.addEventListener('click',function(){closeDrawer(true);});
        drawer.addEventListener('click',function(e){if(e.target.closest('a'))closeDrawer(false);});
        root.addEventListener('keydown',function(e){
          if(!openState())return;
          if(e.key==='Escape'){e.preventDefault();closeDrawer(true);}
          if(e.key==='Tab'){
            var focusable=Array.from(drawer.querySelectorAll('a[href],button:not([disabled])'));
            var first=focusable[0],last=focusable[focusable.length-1];
            if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
            else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
          }
        });
        window.addEventListener('resize',function(){if(window.innerWidth>900)closeDrawer(false);},{passive:true});
        document.addEventListener('shopify:section:unload',function(e){if(e.target.contains(root))closeDrawer(false);});
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();